"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireDefault(require("react"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["className", "size", "role"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var IconShow = function IconShow(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? '' : _ref$size,
    _ref$role = _ref.role,
    role = _ref$role === void 0 ? '' : _ref$role,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", _objectSpread(_objectSpread({
    width: size || '16',
    height: size || '16',
    viewBox: "0 0 16 16",
    fill: "none",
    className: "IconShow ".concat(className),
    xmlns: "http://www.w3.org/2000/svg"
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8 3.27344C4.94303 3.27344 2.17081 4.93139 0.125192 7.62435C-0.0417306 7.84497 -0.0417306 8.1532 0.125192 8.37383C2.17081 11.07 4.94303 12.728 8 12.728C11.057 12.728 13.8292 11.07 15.8748 8.37707C16.0417 8.15645 16.0417 7.84822 15.8748 7.62759C13.8292 4.93139 11.057 3.27344 8 3.27344ZM8.21898 11.3286C6.18973 11.4552 4.51396 9.79721 4.64161 7.78236C4.74634 6.12116 6.10463 4.77468 7.7804 4.67086C9.80966 4.54432 11.4854 6.20227 11.3578 8.21712C11.2498 9.87507 9.89148 11.2216 8.21898 11.3286ZM6.19348 7.8842C6.12147 8.96788 7.02482 9.86012 8.118 9.79199C9.01807 9.73683 9.75122 9.0133 9.81013 8.11457C9.88214 7.03089 8.97879 6.13865 7.88561 6.20679C6.98227 6.26519 6.24912 6.98872 6.19348 7.8842Z",
      fill: "#0A5EC0"
    })
  }));
};
var _default = IconShow;
exports["default"] = _default;